import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function VolumeOffIcon(props, ref) {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "m3.5 3.5 4 4 .003-.003L8.917 8.91l-.003.003L10 10v-.006l2 2V12l2.122 2.121.002-.003 1.415 1.415-.003.003 1.414 1.414.003-.003 1.414 1.414-.003.003L20.5 20.5a1 1 0 0 1-1.414 1.414L12 14.828v3.758c0 .89-1.077 1.337-1.707.707L7 16H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h.172L2.086 4.914A1 1 0 0 1 3.5 3.5ZM7.172 10H5v4h2.828L10 16.17v-3.343L7.172 10Zm7.824 2.162 1.661 1.66c.222-.564.343-1.18.343-1.822 0-1.38-.56-2.632-1.464-3.536a1 1 0 1 0-1.414 1.414 2.987 2.987 0 0 1 .874 2.284Zm3.164 3.164 1.462 1.462A8.961 8.961 0 0 0 21 12a8.975 8.975 0 0 0-2.636-6.364A1 1 0 0 0 16.95 7.05 6.975 6.975 0 0 1 19 12a6.966 6.966 0 0 1-.84 3.326ZM8.917 6.083 12 9.166V5.414c0-.89-1.077-1.337-1.707-.707L8.917 6.083Z"
    })
  });
}
;
VolumeOffIcon.displayName = "VolumeOffIcon";
export default forwardRef(VolumeOffIcon);